import { ReactElement } from 'react'
import { Route } from 'react-router-dom'

import PrivateRouteGuard from '../../components/PrivateRouteGuard'
import { RouteConfig } from './types'

function renderRoute(config: RouteConfig, isPrivate = false): ReactElement {
  const { element: Element, children, path } = config

  const element = isPrivate ? (
    <PrivateRouteGuard>
      <Element />
    </PrivateRouteGuard>
  ) : (
    <Element />
  )

  return (
    <Route key={path} path={path} element={element}>
      {children?.map((child) => (
        <Route key={child.path} path={child.path} />
      ))}
    </Route>
  )
}

export const renderPublicRoute = (config: RouteConfig) => renderRoute(config)
export const renderPrivateRoute = (config: RouteConfig) => renderRoute(config, true)
